import { Injectable, Injector } from "@angular/core";
import { BaseCrudService } from "projects/ProjetoBaseAngular/domain/services/base-crud.service";
import { MetaMsgTemplateParametroModel } from "../models";

@Injectable({
  providedIn: 'root'
})
export class MetaMsgTemplateParametroService extends BaseCrudService<MetaMsgTemplateParametroModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'MetaMsgTemplateParametro';
  }
}
